export default [
  {
    path: '/paraphers/create/',
    component: () => import('../pages/paraphers/create/index'),
    props: true,
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
        { nameI18n: 'navigation.createSignbook' },
      ],
    },
    children: [
      {
        path: '',
        redirect: 'add-parameters',
      },
      {
        path: 'add-parameters',
        name: 'paraphers.create.addParameters',
        component: () => import('../pages/paraphers/create/AddParameters'),
        meta: {
          step: 1,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.createSignbook' },
          ],
        },
      },
      {
        path: 'add-signatories',
        name: 'paraphers.create.addSignatories',
        component: () => import('../pages/paraphers/create/AddSignatories'),
        meta: {
          step: 2,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.createSignbook' },
          ],
        },
      },
      {
        path: 'add-documents',
        name: 'paraphers.create.addDocuments',
        component: () => import('../pages/paraphers/create/AddDocuments'),
        meta: {
          step: 3,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.createSignbook' },
          ],
        },
      },
      {
        path: 'add-signatures',
        name: 'paraphers.create.addSignatures',
        component: () => import('../pages/paraphers/create/AddSignatures'),
        meta: {
          step: 4,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.createSignbook' },
          ],
        },
      },
      {
        path: 'success',
        name: 'paraphers.create.success',
        component: () => import('../pages/paraphers/create/Success'),
        meta: {
          step: 5,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.createSignbook' },
          ],
        },
      },
    ],
  },
  {
    path: '/signworkflows/:tab',
    name: 'signworkflows',
    component: () => import('../pages/signworkflows/signworkflows'),
    props: true,
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'Dashboard', icon: 'home' },
        { nameI18n: '' },
      ],
    },
  },
  {
    path: '/signworkflows/:tab/:signBookId/edit',
    name: 'signworkflow.edit',
    component: () => import('../pages/signworkflows/edit'),
    props: true,
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'Dashboard', icon: 'home' },
        { nameI18n: 'navigation.signbookDetail' },
      ],
    },
  },
  {
    path: '/guestSignworkflows/details',
    name: 'detailsGuestSignworkflow',
    component: () => import('../pages/signworkflows/guestDetails'),
    props: true,
    meta: {
      auth: true,
      guest: true,
    },
  },
  {
    path: '/thirdPartySignworkflow',
    name: 'thirdPartySignworkflow',
    component: () => import('../pages/signworkflows/thirdPartySignworkflow'),
    props: true,
    meta: {
      auth: true,
      guest: true,
    },
  },
  {
    path: '/guestSignworkflows/:signBookId/sign',
    name: 'guestSignworkflows.sign',
    component: () => import('../pages/signworkflows/sign'),
    props: true,
    meta: {
      auth: true,
      guest: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'Dashboard', icon: 'home' },
        { nameI18n: 'navigation.signSignbook' },
      ],
    },
  },
  {
    path: '/guestSignworkflows',
    name: 'guestSignworkflows',
    component: () => import('../pages/signworkflows/guestSignworkflows'),
    props: true,
    meta: {
      auth: true,
      guest: true,
    },
  },
  {
    path: '/guestSignworkflows/access',
    name: 'guestSignworkflows.access',
    component: () => import('../pages/signworkflows/guestSignworkflows'),
    props: true,
    meta: {
      auth: true,
      guest: true,
    },
  },
  {
    path: '/signatories/social',
    name: 'signatories.social.index',
    component: () => import('../pages/signatories/social/index.vue'),
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'Dashboard', icon: 'home' },
        { nameI18n: 'navigation.socialSignatories' },
      ],
    },
  },
  {
    path: '/signatories/social/create',
    name: 'signatories.social.create',
    component: () => import('../pages/signatories/social/create'),
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'Dashboard', icon: 'home' },
        { nameI18n: 'navigation.socialSignatories', link: 'signatories.social.index' },
        { nameI18n: 'navigation.createSocialSignatory' },
      ],
    },
  },
  {
    path: '/signatories/social/:userId',
    name: 'signatories.social.edit',
    props: true,
    component: () => import('../pages/signatories/social/edit.vue'),
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'Dashboard', icon: 'home' },
        { nameI18n: 'navigation.socialSignatories', link: 'signatories.social.index' },
        { nameI18n: '' },
      ],
    },
  },
  {
    path: '/templates/:templateId/use',
    component: () => import('../pages/paraphers/create/index'),
    props: true,
    meta: {
      auth: true,
      breadcrumbs: [
        { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
        { nameI18n: 'navigation.allTemplates', link: 'templates.all' },
        { nameI18n: 'navigation.useTemplate' },
      ],
    },
    children: [
      {
        path: '',
        redirect: 'add-parameters',
      },
      {
        path: 'add-parameters',
        name: 'templates.use.addParameters',
        component: () => import('../pages/paraphers/create/AddParameters'),
        meta: {
          step: 1,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.allTemplates', link: 'templates.all' },
            { nameI18n: 'navigation.useTemplate' },
          ],
        },
      },
      {
        path: 'add-signatories',
        name: 'templates.use.addSignatories',
        component: () => import('../pages/paraphers/create/AddSignatories'),
        meta: {
          step: 2,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.allTemplates', link: 'templates.all' },
            { nameI18n: 'navigation.useTemplate' },
          ],
        },
      },
      {
        path: 'add-documents',
        name: 'templates.use.addDocuments',
        component: () => import('../pages/paraphers/create/AddDocuments'),
        meta: {
          step: 3,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.allTemplates', link: 'templates.all' },
            { nameI18n: 'navigation.useTemplate' },
          ],
        },
      },
      {
        path: 'add-signatures',
        name: 'templates.use.addSignatures',
        component: () => import('../pages/paraphers/create/AddSignatures'),
        meta: {
          step: 4,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.allTemplates', link: 'templates.all' },
            { nameI18n: 'navigation.useTemplate' },
          ],
        },
      },
      {
        path: 'success',
        name: 'templates.use.success',
        component: () => import('../pages/paraphers/create/Success'),
        meta: {
          step: 5,
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.allTemplates', link: 'templates.all' },
            { nameI18n: 'navigation.useTemplate' },
          ],
        },
      },
    ],
  },
  {
    path: '/templates',
    component: () => import('../pages/templates/index.vue'),
    children: [
      {
        path: '',
        name: 'templates.all',
        component: () => import('../pages/templates/all.vue'),
        meta: {
          auth: true,
          breadcrumbs: [
            { nameI18n: 'navigation.home', link: 'dashboard', icon: 'home' },
            { nameI18n: 'navigation.allTemplates' },
          ],
        },
      },
      /* {
        path: 'mine',
        name: 'templates.index.mine',
      }, */
    ],
    meta: {
      auth: true,
    },
  },
];
